module.exports = __webpack_public_path__ + "assets/final-type-5.png";